import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { getDateAgoString } from 'js/lib/DateUtils';

interface TimeAgoProps {
  date: string;
}

export const TimeAgo = (props: TimeAgoProps & TypographyProps) => {
  const { date, ...rest } = props;
  return <Typography {...rest}>{getDateAgoString(date)}</Typography>;
};
